import PDFOrderContainer from 'PDF/Order/PDFOrderContainer';
import BudgetDowload from 'PDF/Presupuesto/BudgetDowload/BudgetDowload';
import BudgetDowloadV2 from 'PDF/PresupuestoV2/BudgetDowload/BudgetDowload';
import BudgetDowloadV3 from 'PDF/PresupuestoV3/BudgetDowload/BudgetDowload';
import { App } from 'antd';
import { getAccessTokenApi } from 'api/auth';
import { getOrderDocumentDataApi, getOrderStaticDatagApi } from 'api/budget';
import axios from 'axios';
import { API_PATH } from 'config';
import { createContext, useContext } from 'react';

const ActionsPresupuestosContext = createContext(null);

export const ActionsPresupuestosProvider = ({ children }) => {
  const { notification } = App.useApp();

  const getDowloadData = async (idBudget) => {
    const token = getAccessTokenApi();
    await axios
      .get(`${API_PATH}/get-budget/${idBudget}`, {
        headers: {
          Authorization: token,
        },
      })
      .then((response) => response.data)
      .then((value) => {
        return value;
      });
  };
  const dowload = async (idBudget) => {
    const token = getAccessTokenApi();
    const data = await axios
      .get(`${API_PATH}/get-budget/${idBudget}`, {
        headers: {
          Authorization: token,
        },
      })
      .then((response) => response.data)
      .then((value) => {
        return value.data;
      });
    const v = Number(data.version);
    let btn;
    if (v >= 3) btn = <BudgetDowloadV3 budget={data} />;
    else if (v === 2) btn = <BudgetDowloadV2 budget={data} />;
    else btn = <BudgetDowload budget={data} />;
    notification.info({
      duration: 30,
      message: `Descargar Presupuesto "${data?.reason}"`,
      btn,
    });
  };
  const dowloadODT = async (id) => {
    const token = getAccessTokenApi();
    try {
      const [docData, staticData] = await Promise.all([
        getOrderDocumentDataApi(token, id),
        getOrderStaticDatagApi(token),
      ]);
      // Response shape: { state, message, order: { order, items } }. Verificar
      // que el fetch fue exitoso y que trae datos antes de renderizar el PDF
      // (evita crash en PDFOrderContainer al hacer const { order, items } = data).
      if (docData?.state !== 'success' || !docData.order?.order) {
        notification.error({
          message: 'No se pudieron cargar los datos de la ODT',
          description: docData?.message || undefined,
        });
        return;
      }
      const config = staticData?.tenant || {};
      notification.open({
        duration: 30,
        message: `Descargar Orden de Trabajo N°${id}`,
        btn: <PDFOrderContainer idBudget={id} config={config} data={docData.order} />,
      });
    } catch (err) {
      notification.error({ message: err?.message || 'Error al cargar la ODT' });
    }
  };

  return (
    <ActionsPresupuestosContext.Provider
      value={{
        getDowloadData,
        dowload,
        dowloadODT,
      }}
    >
      {children}
    </ActionsPresupuestosContext.Provider>
  );
};

export const useActionsPresupuestos = () => useContext(ActionsPresupuestosContext);
